import CardMedia from '/components/Widgets/CardMedia.svelte'
import ContentBox from '/components/Atoms/Card.svelte'

export function mapTypeHandleToComponent(w) {

  // gather information
  const bgImage = w?.backgroundImage?.[0]?.url
  const bgImage2x = w?.backgroundImage?.[0]?.url2x
  const title = w.title
  const text = w.widgetText
  const entryType = w.typeHandle
  const contentType = w.widgetSubType 
  const linkedContent = w?.linkedContent?.[0]
  const typeHandle = linkedContent?.typeHandle
  const link = linkedContent ? { slug: linkedContent.slug, section: "almanac" } : null

  //// linked content widgets ////

  if (entryType === "contentWidget") {

    const people = linkedContent?.relatedPeople?.[0]?.members?.map(member => member.title).join(", ")
    const category = linkedContent?.textMediaCategory

    // CARDS - small and large
    if (["2021HomepageFeaturedContent"].includes(contentType)) {

      return {
        component: CardMedia,
        props: {
          category,
          title: text,
          subtitle: people,
          image: bgImage,
          image2x: bgImage2x,
          standardRadius: true,
          typeHandle,
          link
        }
      }
    }
  }

  return {
    component: ContentBox,
    content: JSON.stringify(w)
  }

}


